import { WILLS_PLAN_PRICE } from '@/constants'

export const getPlanPrice = (isFakeDiscount = false) => {
  const fullEstatePlanPrice = WILLS_PLAN_PRICE.fullEstatePlanPrice
  const basicWillPlanPrice = WILLS_PLAN_PRICE.basicWillPlanPrice

  if (isFakeDiscount) {
    return {
      willPrice: basicWillPlanPrice,
      trustPrice: fullEstatePlanPrice,
      willOriginalPrice: 199,
      trustOriginalPrice: 449,
      willDiscount: 50,
      trustDiscount: 100,
    }
  }

  return {
    willPrice: basicWillPlanPrice,
    trustPrice: fullEstatePlanPrice,
    willOriginalPrice: undefined,
    trustOriginalPrice: undefined,
    willDiscount: undefined,
    trustDiscount: undefined,
  }
}
